"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastContainerStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
const ToastContainerStyled = (0, _styled.default)("div")`
    transition: opacity ${_designTokens.motion.animation.default}, transform ${_designTokens.motion.animation.default};

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;

    // We attach this so we can capture the mouse enter events between the toasts themselves.
    // This is necessary to prevent the auto-close timer from firing when the user is interacting
    // with the toast stack.
    padding-top: ${_designTokens.space.space30};

    width: var(--sds-toast--container-width, 450px);
`;
exports.ToastContainerStyled = ToastContainerStyled;
//# sourceMappingURL=ToastContainerStyled.js.map